export interface State {
  current_page: number
  total_count: number
  detail: Array<any>
  params: Params
  choosed_detail: Array<any>
  corporate_name: string
}

export interface Params {
  target_corporate_number: string
  issuer_product_name: string
  document_type: string
  file_name: string
  revision_date_start: string
  revision_date_end: string
  latest_edition_flag: boolean
  sort_column: string
  sort: string
  page_size: number
  page_number: number
}

const state = (): State => ({
  current_page: 0,
  total_count: 0,
  detail: [],
  params: {
    target_corporate_number: '',
    issuer_product_name: '',
    document_type: '',
    file_name: '',
    revision_date_start: '',
    revision_date_end: '',
    latest_edition_flag: true,
    sort_column: 'issuer_product_name',
    sort: 'ASC',
    page_size: 20,
    page_number: 1,
  },
  choosed_detail: [],
  corporate_name: '',
})

export default state
